import { render, staticRenderFns } from "./ObjectivePanel.vue?vue&type=template&id=b3644abe&scoped=true&"
import script from "./ObjectivePanel.vue?vue&type=script&lang=js&"
export * from "./ObjectivePanel.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivePanel.vue?vue&type=style&index=0&id=b3644abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3644abe",
  null
  
)

export default component.exports